/* eslint-disable no-sequences */
import React from 'react';
import Components from 'mpm-components';
import { Form, Accordion, Icon, Popup, Button } from 'semantic-ui-react';
import { DateInput } from 'semantic-ui-calendar-react';
import copy from 'copy-to-clipboard';
import NumberFormat from 'react-number-format';
export default ({ cessionExport, entities, pays, setCessionExport }) => {
  const [activeIndex, setActiveIndex] = React.useState(0);
  const handleAccordionClick = (e, titleProps) => {
    const { index } = titleProps;

    const newIndex = activeIndex === index ? -1 : index;
    setActiveIndex(newIndex);
  };
  return (
    <>
      <Components.Regions.RegionWithHeader title="menu.demande.export" headerColor="blue" headerSize="small">
        <Form>
          <Form.Group widths="equal">
            <Form.Checkbox toggle value={cessionExport.certificatManuelle} label="Choisir Demande SAP" disabled />

            {cessionExport.certificatManuelle ? (
              <>
                <DateInput
                  label={
                    <label>
                      Date Cértificat Exportation SAP<font color="red">*</font>
                    </label>
                  }
                  clearable
                  closable
                  type="text"
                  name="dateVisa"
                  icon="calendar"
                  iconPosition="right"
                  maxDate={new Date()}
                  value={cessionExport.dateVisa}
                  animation="fade"
                  autoComplete="off"
                  dateFormat="DD/MM/YYYY"
                  disabled
                />
                <Form.Input required label="Numéro Cértificat Exportation SAP" value={cessionExport.numeroCertificat} disabled />
              </>
            ) : (
              <>
                <Form.Field />
                <Form.Field />
              </>
            )}
          </Form.Group>

          <Form.Group widths="equal">
            <Form.Input
              type="text"
              readonly="readonly"
              label="Référence Demande Exportation"
              value={cessionExport.numeroCessionComplet}
              onChange={(event) => {}}
              action={
                <Popup
                  content="Copier"
                  trigger={
                    <Button icon onClick={() => copy(cessionExport.numeroCessionComplet)}>
                      <Icon name="copy" />
                    </Button>
                  }
                />
              }
            />
            <Form.Input label="Date Système " value={cessionExport.dateSysteme} disabled />
            <DateInput
              label={
                <label>
                  Date Demande Exportation<font color="red">*</font>
                </label>
              }
              clearable
              closable
              type="text"
              name="dateCession"
              icon="calendar"
              iconPosition="right"
              maxDate={new Date()}
              value={cessionExport.dateCession}
              animation="fade"
              autoComplete="off"
              dateFormat="DD/MM/YYYY"
              disabled
            />
          </Form.Group>
          <Form.Group widths="equal">
            <Form.Select label="DPM De Validation" required options={entities.data} value={cessionExport.id_RefDpmValid} disabled />

            <Form.Field />
            <Form.Field />
          </Form.Group>
        </Form>
      </Components.Regions.RegionWithHeader>

      <Components.Regions.RegionWithHeader title="label.sources" headerColor="blue" headerSize="small" striped={false}>
        <Accordion styled fluid>
          {cessionExport.childrenSourceEXP &&
            cessionExport.childrenSourceEXP.map(
              (source, index) =>
                source.childrenSrcEsp && (
                  <span key={source.id}>
                    <Accordion.Title active={activeIndex === index} index={index} onClick={handleAccordionClick}>
                      <Icon name="dropdown" />
                      Source :{source.typeSource}- {source.codeSource}
                    </Accordion.Title>

                    <Accordion.Content active={activeIndex === index}>
                      <Components.Tables.SmartTable
                        header={[
                          {
                            selector: 'refEspece.libelle',
                            label: 'Espece',
                          },
                          {
                            selector: 'disponible',
                            label: 'Quantité Disponible en (KG)',
                            component: (row) => <NumberFormat min={0} displayType={'text'} thousandSeparator=" " decimalScale={3} allowedDecimalSeparators={('.', ',')} value={row.disponible} />,
                          },
                          {
                            selector: 'poidCD',
                            label: 'Poids CD (KG)',
                            component: (row) => <NumberFormat min={0} displayType={'text'} thousandSeparator=" " decimalScale={3} allowedDecimalSeparators={('.', ',')} value={row.poidCD} />,
                          },
                          {
                            selector: 'poidExporte',
                            label: 'Poids Exporté (KG)',
                            component: (row) => <NumberFormat min={0} displayType={'text'} thousandSeparator=" " decimalScale={3} allowedDecimalSeparators={('.', ',')} value={row.poidExporte} />,
                          },
                          {
                            selector: 'rendementG',
                            textAlign: 'center',
                            label: 'Rendement G',
                            component: (row) => <NumberFormat min={0} displayType={'text'} thousandSeparator=" " decimalScale={3} allowedDecimalSeparators={('.', ',')} value={row.rendementG} />,
                          },
                        ]}
                        data={source.childrenSrcEsp}
                        grouped={true}
                        groupeBy="refEspece.libelle"
                        groupeSums={['disponible', 'poidCD', 'poidExporte']}
                        rowsPerPage={5}
                        striped={true}
                        sortable={false}
                      />
                    </Accordion.Content>
                  </span>
                )
            )}
        </Accordion>
      </Components.Regions.RegionWithHeader>
      <Components.Regions.RegionWithHeader title="menu.demande.export.transport-data" headerColor="blue" headerSize="small">
        <Form>
          <Form.Group widths="equal">
            <Form.Select required label="Pays d'exportation" options={pays.data} loading={pays.loading} error={pays.error} value={cessionExport.id_RefPaysExp} disabled />
            <Form.Input label="Numéro cértificat vétérinaire" value={cessionExport.numeroCertificatVeterinaire} disabled />
            <Form.Input label="Nom Importateur " value={cessionExport.nomImportateur} disabled />
          </Form.Group>
          <Form.Group widths="equal">
            <Form.Input label="Port / Aéroport / Autre Lieu de départ" required value={cessionExport.lieuDepart} disabled />
            <Form.Input label="Numéro Vol / Numéro lettre transport" value={cessionExport.numeroVol} disabled />
            <Form.Input label="Numéro lettre de voiture ferroviaire" value={cessionExport.numeroVoitureFerro} disabled />
          </Form.Group>
          <Form.Group widths="equal">
            <Form.Input label="Autres documents" value={cessionExport.autreDocs} disabled />
            <Form.Input label="Numéro du(des) conteneur(s)" value={cessionExport.numeroConteneur} disabled />
            <Form.Field />
          </Form.Group>
        </Form>
      </Components.Regions.RegionWithHeader>
    </>
  );
};
